/* eslint react/prop-types: 0 */
import React from 'react';
import { lowerCase } from 'lodash';
import { formatSalePrice } from '../../utils/money';
import { formatDate } from '../../utils/date';
import SalesHorseLink from '../../shared/links/SalesHorseLink';
import Abbr from '../../shared/Abbr';

const columns = [
    {
        key: 'saleDate',
        header: 'date',
        cell: data => (
            <SalesHorseLink {...data} >
                <Abbr
                    title={formatDate(data.saleDate, 'dddd, DD MMMM YYYY')}
                    breakpoint="exWide"
                >
                    {formatDate(data.saleDate, 'DDMMMYY')}
                </Abbr>
            </SalesHorseLink>
        ),
    },
    {
        key: 'abbrevName',
        header: 'sale name',
        cell: ({ abbrevName, venueDesc }) => (
            <div>
                <span className="hidden-sm-down">{abbrevName}</span>
                <span className="hidden-md-up">{lowerCase(venueDesc)}</span>
            </div>
        ),
    },
    {
        key: 'lotNo',
        header: 'lot',
    },
    {
        key: 'sellerName',
        header: 'vendor',
    },
    {
        key: 'buyerDetail',
        header: 'purchaser',
    },
    {
        key: 'price',
        header: 'price',
        cell: ({ price, curCode }) => formatSalePrice(price, curCode),
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/horse/sales/columns.jsx